import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Select from 'react-select'

const setGroupLesson = (handler, payload) => {
  handler({
    target: {
      name: 'groupLesson',
      value: payload.value,
    },
  })
}

const GroupLessons = ({ value, options, onChange, children }) => (
  <div className="fieldset-wrap" id="group-lessons">
    <fieldset className="fieldset">
      <legend className="legend">
        <div className="form-group form-group__legend form-group__with-info info__pin-right">
          5. Group lessons or clinics<br />
          <small>If you have group lessons, choose when the next lessons will be held.</small>
          {/*
            <Info className="info__pin-right">
                The default working hours can be changed later.
                You can also easily block times from your calendar, so it's better to have more than less open times.
            </Info>
            */}
        </div>
      </legend>
      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <Select
              clearable={false}
              searchable={false}
              value={value}
              options={options}
              onChange={payload => setGroupLesson(onChange,payload)}
            />
          </div>
        </Col>
      </Row>
      { children }
    </fieldset>
  </div>
)


export default GroupLessons;



// WEBPACK FOOTER //
// ./src/components/GroupLessons/GroupLessons.js